import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { McpAccessProfile } from '../../../Api/McpAccess';

export interface McpAccessRevokeConfirmDialogProps {
  open: boolean;
  profile: McpAccessProfile | null;
  submitting: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const McpAccessRevokeConfirmDialog = ({
  open,
  profile,
  submitting,
  onConfirm,
  onClose
}: McpAccessRevokeConfirmDialogProps) => {
  if (!profile) return null;
  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      data-testid="mcp-revoke-confirm-dialog"
      aria-labelledby="mcp-revoke-confirm-title">
      <DialogTitle id="mcp-revoke-confirm-title">Revoke MCP access?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Revoking <strong>{profile.title}</strong> will immediately invalidate its token. This cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={submitting}
          data-testid="mcp-revoke-cancel">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={submitting}
          color="error"
          variant="contained"
          data-testid="mcp-revoke-confirm"
          startIcon={
            submitting ? (
              <CircularProgress
                size={16}
                color="inherit"
              />
            ) : null
          }>
          {submitting ? 'Revoking…' : 'Revoke'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
